import { apiSlice } from "../api/apiSlice";

export const videosApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => ({
        url: "/videos",
        method: "GET",
      }),
    }),
    getVideo: builder.query({
      query: (id) => ({
        url: `/videos/${id}`,
        method: "GET",
      }),
    }),
    editVideo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/videos/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: editedVideo } = await queryFulfilled;

          // Update the getVideos cache if the video was edited successfully
          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              const draftVideo = draft.find(
                (video) => video.id == editedVideo.id
              );
              draftVideo.title = editedVideo.title;
              draftVideo.description = editedVideo.description;
              draftVideo.url = editedVideo.url;
              draftVideo.views = editedVideo.views;
              draftVideo.duration = editedVideo.duration;
              draftVideo.createdAt = editedVideo.createdAt;
            })
          );
        } catch (error) {
          //Nothing to do
        }
      },
    }),
    addVideo: builder.mutation({
      query: (data) => ({
        url: `/videos`,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: addedVideo } = await queryFulfilled;

          // Update the getVideos cache if the video was added successfully
          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              draft.push(addedVideo);
            })
          );
        } catch (error) {
          //Nothing to do
        }
      },
    }),

    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `/videos/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: deletedVideo } = await queryFulfilled;

          // Update the getVideos cache if the video was deleted successfully
          if (deletedVideo) {
            dispatch(
              apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                // Remove the deleted video from the cache
                return draft.filter((video) => video.id !== arg);
              })
            );
          }
        } catch (error) {
          //Nothing to do
        }
      },
    }),
  }),
});

export const {
  useAddVideoMutation,
  useEditVideoMutation,
  useDeleteVideoMutation,
  useGetVideoQuery,
  useGetVideosQuery,
} = videosApi;
